/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ArtifactToolCallResponseContent } from './ArtifactToolCallResponseContent';
import {
    ArtifactToolCallResponseContentFromJSON,
    ArtifactToolCallResponseContentFromJSONTyped,
    ArtifactToolCallResponseContentToJSON,
    ArtifactToolCallResponseContentToJSONTyped,
} from './ArtifactToolCallResponseContent';

/**
 * 
 * @export
 * @interface ArtifactToolCallResponse
 */
export interface ArtifactToolCallResponse {
    /**
     * 
     * @type {string}
     * @memberof ArtifactToolCallResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ArtifactToolCallResponse
     */
    messageId: string | null;
    /**
     * 
     * @type {string}
     * @memberof ArtifactToolCallResponse
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof ArtifactToolCallResponse
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof ArtifactToolCallResponse
     */
    kind: ArtifactToolCallResponseKindEnum;
    /**
     * 
     * @type {ArtifactToolCallResponseContent}
     * @memberof ArtifactToolCallResponse
     */
    content: ArtifactToolCallResponseContent;
}


/**
 * @export
 */
export const ArtifactToolCallResponseKindEnum = {
    ToolCallResponse: 'tool-call-response'
} as const;
export type ArtifactToolCallResponseKindEnum = typeof ArtifactToolCallResponseKindEnum[keyof typeof ArtifactToolCallResponseKindEnum];


/**
 * Check if a given object implements the ArtifactToolCallResponse interface.
 */
export function instanceOfArtifactToolCallResponse(value: object): value is ArtifactToolCallResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('messageId' in value) || value['messageId'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('kind' in value) || value['kind'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function ArtifactToolCallResponseFromJSON(json: any): ArtifactToolCallResponse {
    return ArtifactToolCallResponseFromJSONTyped(json, false);
}

export function ArtifactToolCallResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArtifactToolCallResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'messageId': json['messageId'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'kind': json['kind'],
        'content': ArtifactToolCallResponseContentFromJSON(json['content']),
    };
}

export function ArtifactToolCallResponseToJSON(json: any): ArtifactToolCallResponse {
    return ArtifactToolCallResponseToJSONTyped(json, false);
}

export function ArtifactToolCallResponseToJSONTyped(value?: ArtifactToolCallResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'messageId': value['messageId'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'kind': value['kind'],
        'content': ArtifactToolCallResponseContentToJSON(value['content']),
    };
}

